/* global Swiper */

/* global cartGiftsEnabled */

/* global cartGiftLimits */

/* global eggoABC */

import {hideDomElement} from "../helpers";

/** The config globals come from inline scripts built from theme settings; a store without those settings has none of them. */
const getAbcConfig = () => (typeof eggoABC === "undefined" ? [] : eggoABC);
const getAbcRegistered = () => (typeof eggoABCRegistered === "undefined" ? [] : eggoABCRegistered);
const areGiftsEnabled = () => typeof cartGiftsEnabled !== "undefined" && Boolean(cartGiftsEnabled);

export class EggoCartDiscountLogic {
    /** cart is the Shopify cart JSON (same shape as /cart.js); prices are in cents and already include discounts. */
    constructor(EggoCart, cart) {
        this.eggoCart = EggoCart;
        this.cart = cart;
        this.cartPrice = this.cart.total_price / 100;
        this.cartIndex = this.createCartIndex();
        this.giftDomElements = this.eggoCart.querySelectorAll(".cart-drawer__inner-real .cart-drawer__gift");
        this.abcDomElements = this.eggoCart.querySelectorAll(".cart-drawer__inner-real .cart-drawer__upsell-item");
        this.giftIds = this.getGiftIds();
        this.abcIds = this.getAbcIds();
        const upsellSectionIsHidden = this.runUpsellLogic();
        const giftSectionIsHidden = this.runGiftLogic();
        if (upsellSectionIsHidden && (giftSectionIsHidden || !areGiftsEnabled())) {
            this.hideBothSections();
        } else {
            new Swiper('.cart-drawer__inner-real .cart-drawer-product-card__list', {
                loop: false,
                spaceBetween: 16
            });
        }
    }


    createCartIndex() {
        return this.cart.items.reduce((cartIndex, cartItem) => {
            cartIndex[cartItem.product_id] = cartItem;
            return cartIndex;
        }, {})
    }

    getGiftIds() {
        if (!this.giftDomElements) return [];
        return [...this.giftDomElements].reduce((giftList, giftDomElement) => {
            giftList.push(giftDomElement.dataset.productId);
            return giftList;
        }, [])
    }

    getAbcIds() {
        if (!this.abcDomElements) return [];
        return [...this.abcDomElements].reduce((abcList, abcDomElement) => {
            abcList.push(abcDomElement.dataset.productId);
            return abcList;
        }, [])
    }

    runUpsellLogic() {
        let hideUpsellSection = true;

        /* Those are all of the discounts that can be visible on the page */
        let availableABCDiscounts = getAbcRegistered();
        let possibleABCDiscounts = new Set(getAbcConfig().reduce((all, upsell) => {
            if (this.cartIndex?.[upsell.product]) {
                return [...all, ...upsell.associations];
            }
            return all;
        }, []));

        let discountsAlreadyInTheCart = new Set(getAbcConfig().reduce((all, upsell) => {
            upsell.associations.forEach((association) => {
                if (this.cartIndex?.[association]) {
                    all.push(association.toString());
                }
            });
            return all;
        }, []));
        const discountsNotInTheCart = {};
        availableABCDiscounts.forEach((discountId) => {
                const discountDomElement = document.querySelector(`.cart-drawer__inner-real .cart-drawer__upsell-item[data-product-id="${discountId}"]`);
                if (possibleABCDiscounts.has(discountId) && !discountsAlreadyInTheCart.has(discountId)) {
                    if (discountDomElement) hideUpsellSection = false;
                    discountsNotInTheCart[discountId] = 0;
                    return;
                }
                hideDomElement(discountDomElement);
            }
        )

        this.runAbcOrderDiscount(discountsNotInTheCart);
        if(hideUpsellSection) this.hideUpsellSection();
        return hideUpsellSection;
    }

    runAbcOrderDiscount(discountsInTheCart){
        try {
            this.cart.items.forEach((item) => {
                const productId = item.product_id;
                const abcProduct = this.findProductInEggoAbc(productId);
                if(!abcProduct) return;
                const associations = abcProduct.associations;
                associations.forEach((associationId, index) => {
                    if(discountsInTheCart?.[associationId] !== null){
                        discountsInTheCart[associationId] += index;
                    }
                })
            });
        }
        catch(error){
            // No items in the cart. No damage here.
        }
        const allElements = document.querySelectorAll(`.cart-drawer__inner-real .cart-drawer__upsell-item`)

        allElements.forEach((element) => {
            element.style.order = 100000;
        })

        Object.entries(discountsInTheCart).forEach(([discountId, order]) => {
            const productElement = document.querySelector(`.cart-drawer__inner-real .cart-drawer__upsell-item[data-product-id="${discountId}"]`)
            if(!productElement) return;
            productElement.style.order = order;
        } );
    }

    findProductInEggoAbc(productId){
        for(let product of getAbcConfig()){
            if(product.product == productId){
                return product;
            }
        }
        return null;
    }

    runGiftLogic() {
        const giftInTheCart = this.giftIds.find(giftId => this.cartIndex?.[giftId]);
        if (giftInTheCart) {
            this.hideGiftSection();
            return true;
        }

        const giftRule = this.generateGiftRule();
        if (giftRule.locked === null && giftRule.unlocked === null) {
            this.hideGiftSection();
            return true;
        }
        if (giftRule.locked) this.showLockedGifts(giftRule.locked);
        if (giftRule.unlocked) this.showUnlockedGifts(giftRule.unlocked);
        if (giftRule.messageValue) {
            const valueTexts = document.querySelectorAll(".cart-drawer-product-card__message-locked-text");
            valueTexts.forEach(text => text.innerHTML = Shopify.formatMoney(giftRule.messageValue * 100));
        }
        this.hideOtherGifts();

        /** A tier without a gift product leaves the section empty: hide it instead of showing a title with no cards. */
        const noGiftIsShown = ![...this.giftDomElements].some((giftDomElement) => giftDomElement.classList.contains("show"));
        if (noGiftIsShown) this.hideGiftSection();
        return noGiftIsShown;
    }

    /**
     * Cart line keys of gifts added through the gift offer (hidden `_eggo_gift` line property = tier) whose
     * threshold is no longer met by the rest of the cart. Gift products bought on their own have no property
     * and are never touched.
     */
    findGiftsToRemove() {
        if (typeof cartGiftLimits === "undefined" || !areGiftsEnabled()) return [];
        const tierIndex = {"50": 0, "60": 1, "80": 2, "100": 3};
        return this.cart.items.reduce((keys, line) => {
            const tier = cartGiftLimits[tierIndex[line.properties?._eggo_gift]];
            if (!tier) return keys;
            const totalWithoutGift = (this.cart.total_price - line.final_line_price) / 100;
            if (totalWithoutGift < tier["low"]) keys.push(line.key);
            return keys;
        }, []);
    }

    hideUpsellSection() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell-eggo");
    }

    hideGiftSection() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell-gift");
    }

    hideBothSections() {
        this.hideSection(".cart-drawer__inner-real .cart-drawer__upsell");
    }

    hideSection(className) {
        const section = this.eggoCart.querySelector(className);
        if (!section) return;
        section.classList.add("hide-this");
    }

    generateGiftRule() {
        const noGift = {locked: null, unlocked: null, messageValue: ""};
        const giftState = {locked: null, unlocked: null, messageValue: ""};
        if (typeof cartGiftLimits === "undefined") return noGift;
        this.cartPrice = this.cart.total_price / 100;
        if (!this.cartPrice) return noGift;
        /** If the cartValue is giftLimit close to gift it will show as locked **/

        if (this.cartPrice >= cartGiftLimits[0]["low"] && this.cartPrice < cartGiftLimits[0]["high"]) {
            giftState.unlocked = 50;
        } else if (this.cartPrice >= cartGiftLimits[1]["low"] && this.cartPrice < cartGiftLimits[1]["high"]) {
            giftState.unlocked = 60;
        } else if (this.cartPrice >= cartGiftLimits[2]["low"] && this.cartPrice < cartGiftLimits[2]["high"]) {
            giftState.unlocked = 80;
        } else if (this.cartPrice >= cartGiftLimits[3]["low"] && this.cartPrice < cartGiftLimits[3]["high"]) {
            giftState.unlocked = 100;
        }

        if (this.cartPrice >= (cartGiftLimits[0]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[0]["low"]) {
            giftState.locked = 50;
            giftState.messageValue = cartGiftLimits[0]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[1]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[1]["low"]) {
            giftState.locked = 60;
            giftState.messageValue = cartGiftLimits[1]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[2]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[2]["low"]) {
            giftState.locked = 80;
            giftState.messageValue = cartGiftLimits[2]["low"];
        } else if (this.cartPrice >= (cartGiftLimits[3]["low"] - cartGiftsRange) && this.cartPrice < cartGiftLimits[3]["low"]) {
            giftState.locked = 100;
            giftState.messageValue = cartGiftLimits[3]["low"];
        }
        return giftState;
    }


    showLockedGifts(giftPrice) {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (giftDomElement.dataset.price === giftPrice.toString()) {
                giftDomElement.classList.add("lock");
                giftDomElement.classList.add("show");
            }
        });
    }

    showUnlockedGifts(giftPrice) {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (giftDomElement.dataset.price === giftPrice.toString()) {
                giftDomElement.classList.add("unlock");
                giftDomElement.classList.add("show");
            }
        });
    }

    hideOtherGifts() {
        [...this.giftDomElements].forEach((giftDomElement) => {
            if (!giftDomElement.classList.contains("show")) {
                hideDomElement(giftDomElement);
            }
        });
    }
}